export default __webpack_public_path__ + "static/media/allow-unpaid-orders.6ea42f8c.svg";